import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { MaintenancesApi } from '@api/maintenances/maintenances.api';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { Maintenance, Quotation } from '@core/interfaces';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { DialogQuotationComponent, QuotationDialogData } from 'app/main/quotations/dialog/dialog-quotation.component';
import { ReloadResult } from 'app/main/quotations/quotations.component';
import { QuotationService } from 'app/main/quotations/services/quotation.service';
import { sumBy } from 'lodash';
import { debounceTime } from 'rxjs/operators';
import english from '../../../../i18n/en.json';
import spanish from '../../../../i18n/es.json';
import portuguese from '../../../../i18n/pt.json';
import { DialogCreateMaintenanceComponent } from '../../../dialog-create-maintenance/dialog-create-maintenances.component';
import { MaintenanceDialogData } from '../../dialog-maintenances.component';


@Component({
  selector: 'tab-quotations',
  templateUrl: './tab-quotations.component.html',
  styleUrls: ['./tab-quotations.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TabQuotationsComponent implements OnInit {
  public quotations: Quotation[] = [];
  public hasEditQuotationPermission = this.authenticationService.hasPermission('quotations-edit');
  public hasPaymentsBetaFlag = this.authenticationService.hasFlags('paymentsFeatureFlag');
  private maintenance: Maintenance;

  public constructor(
    @Inject(MAT_DIALOG_DATA) public data: MaintenanceDialogData,
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private quotationsService: QuotationService,
    private fuseProgressBarService: FuseProgressBarService,
    private authenticationService: AuthenticationService,
    public readonly matDialogRef: MatDialogRef<DialogCreateMaintenanceComponent, ReloadResult>,
    private matDialog: MatDialog,
    private maintenancesApi: MaintenancesApi
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({english, portuguese, spanish});
    this.maintenance = data.maintenance;
  }

  async ngOnInit(): Promise<void> {
    await this.getQuotations();

    for (const quotation of this.quotations) {
      const services = quotation.items.filter((item) => item.productService.type === 'service');
      const products = quotation.items.filter((item) => item.productService.type === 'product');
      quotation.productsCount = sumBy(products, 'quantity');
      quotation.servicesCount = sumBy(services, 'quantity');
      quotation.productsValueTotal = sumBy(products, 'total');
      quotation.servicesValueTotal = sumBy(services, 'total');
      quotation.expensesValueTotal = sumBy(quotation.expenses, 'value');
    }
  }

  async openDialog(quotationId?: string): Promise<void> {
    this.fuseProgressBarService.show();
    if (quotationId) {
      const quotation = await this.quotationsService.getById(quotationId);
      this.fuseProgressBarService.hide();

      const result = await this.matDialog.open<any, QuotationDialogData, ReloadResult>(DialogQuotationComponent, {
        panelClass: 'dialog-quotation',
        data: {
          quotation,
          isViewMode: !this.hasEditQuotationPermission
        }
      })
        .afterClosed()
        .toPromise();

      if (result && result.reload) {
        this.fuseProgressBarService.show();

        this.getQuotations();
        this.fuseProgressBarService.hide();

      }
    }
  }

  async getQuotations(): Promise<void> {
    await this.maintenancesApi
      .searchMaintenanceQuotations({ maintenanceId: this.maintenance.id })
      .pipe(debounceTime(500))
      .toPromise()
      .then((quotations) => {
          quotations.map((quotation) => {
            const services = quotation.items.filter((item) => item.productService.type === 'service');
            const products = quotation.items.filter((item) => item.productService.type === 'product');

            quotation.productsCount = sumBy(products, 'quantity');
            quotation.servicesCount = sumBy(services, 'quantity');
            quotation.productsValueTotal = sumBy(products, 'total');
            quotation.servicesValueTotal = sumBy(services, 'total');

            return quotation;
          });

          this.quotations = quotations;

      });
  }
}
